module.exports = __webpack_public_path__ + "img/marmelaedchen-teich_xs.017ba4d5.jpg";